import DepositsIcon from '../icons/DepositsDebits.svg';
import TransactionsIcon from '../icons/Transactions.svg';
import ResidentsIcon from '../icons/Residents.svg';
import ResidentTopLevelIcon from '../icons/residents-toplevel.svg';
import AccountManagementIcon from '../icons/PMAccountManagementIcon.svg';
import PropertiesIcon from '../icons/Properties.svg';
import BankAccountsIcon from '../icons/BankAccounts.svg';
import IntegrationsIcon from '../icons/Integrations.svg';
import PaymentRequestsIcon from '../icons/PaymentRequests.svg'; //for now
import DashboardIcon from '../icons/dashboard_home_icon.svg';
import DollarIcon from '../icons/DollarIcon.svg';
import SettingsIcon from '../icons/SettingsIcon.svg';
import ConfigSettingsIcon from '../icons/Configurations.svg';
import WhiteProfileSettingsIcon from '../icons/WhiteProfileSettingsIcon.svg';
import EmailReportsIcon from '../icons/EmailReportsIcon.svg';
import LegalAndTaxIcon from '../icons/LegalTaxIcon.svg';
import InvoicingIcon from '../icons/Billing.svg';
import OwnersIcon from '../icons/OwnersIcon.svg';
import VendorsIcon from '../icons/vendor-icon-pmui.svg';
import OwnerDistributionsIcon from '../icons/OwnerDistributionsIcon.svg';
import MaintenanceIcon from '../icons/MaintenanceLogo.svg';
import ApplicationsIcon from '../icons/PmApplicationsIcon.svg';
import BillingConfigIcon from '../icons/billing_config.svg';
import { IpaUserExtended } from '../shared/sagas/auth/authSlice';
import { Role } from '@inosio/payments-sdk';

export interface PmUiLink {
  Text: string;
  Icon: string;
  path?: string;
  isSubMenu?: boolean; //likely shouldn't need this.
  subLinks?: PmUiLink[];
  hideCopyRight?: boolean; //if true, then the copyright icon won't be on the bottom of the page
}

export class LinkBuilder {
  //#region create link objects
  private dashboardLink: PmUiLink = {
    Text: 'Dashboard',
    Icon: DashboardIcon,
    path: `${this.baseUrl}/dashboard`,
  };

  private paymentsLink: PmUiLink = {
    Text: 'Payments',
    Icon: DollarIcon,
    isSubMenu: true,
  };

  private transactionsLink: PmUiLink = {
    Text: 'Transactions',
    Icon: TransactionsIcon,
    path: `${this.baseUrl}/transactions`,
    hideCopyRight: true,
  };

  private depDebLink: PmUiLink = {
    Text: 'Deposits & Debits',
    Icon: DepositsIcon,
    path: `${this.baseUrl}/deposits`,
    hideCopyRight: true,
  };

  private pmtReqLink: PmUiLink = {
    Text: 'Payment Requests',
    Icon: PaymentRequestsIcon,
    path: `${this.baseUrl}/paymentrequests`,
    hideCopyRight: true,
  };

  private bankAccountLink: PmUiLink = {
    Text: 'Bank Accounts',
    Icon: BankAccountsIcon,
    path: `${this.baseUrl}/bankaccounts`,
    hideCopyRight: true,
  };

  private ownerDistLink: PmUiLink = {
    Text: 'Owner Distributions',
    Icon: OwnerDistributionsIcon,
    path: `${this.baseUrl}/ownerdistributions`,
    hideCopyRight: true,
  };

  private entitiesLink: PmUiLink = {
    isSubMenu: true,
    Text: 'Resident Submenu',
    Icon: ResidentTopLevelIcon,
  };

  private residentsLink: PmUiLink = {
    Text: 'Residents',
    Icon: ResidentsIcon,
    path: `${this.baseUrl}/residents`,
    hideCopyRight: true,
  };

  private propertiesLink: PmUiLink = {
    Text: 'Properties',
    Icon: PropertiesIcon,
    path: `${this.baseUrl}/properties`,
    hideCopyRight: true,
  };

  private ownersLink: PmUiLink = {
    Text: 'Owners',
    Icon: OwnersIcon,
    path: `${this.baseUrl}/owners`,
    hideCopyRight: true,
  };

  private vendorsLink: PmUiLink = {
    Text: 'Vendors',
    Icon: VendorsIcon,
    path: `${this.baseUrl}/vendors`,
    hideCopyRight: true,
  };

  private integrationsLink: PmUiLink = {
    Text: 'Integrations Marketplace',
    Icon: IntegrationsIcon,
    path: `${this.baseUrl}/integrations`,
  };

  private applicationsLink: PmUiLink = {
    Text: 'Applications',
    Icon: ApplicationsIcon,
    path: `${this.baseUrl}/applications`,
    hideCopyRight: true,
  };

  private maintenanceLink: PmUiLink = {
    Text: 'Work Orders',
    Icon: MaintenanceIcon,
    path: `${this.baseUrl}/workorders`,
    hideCopyRight: true,
  };

  private staffManagementLink: PmUiLink = {
    Text: 'User Management',
    Icon: AccountManagementIcon,
    path: `${this.baseUrl}/accountManagement`,
    hideCopyRight: true,
  };

  private settingsLink: PmUiLink = {
    isSubMenu: true,
    Text: 'Settings Submenu',
    Icon: SettingsIcon,
  };

  private profileSettingsLink: PmUiLink = {
    Text: 'Profile Settings',
    Icon: WhiteProfileSettingsIcon,
    path: `${this.baseUrl}/profilesettings`,
  };

  private configLink: PmUiLink = {
    Text: 'Configuration & Settings',
    Icon: ConfigSettingsIcon,
    path: `${this.baseUrl}/propertygroups`,
  };

  private emailReportsLink: PmUiLink = {
    Text: 'Email Reports',
    Icon: EmailReportsIcon,
    path: `${this.baseUrl}/emailreports`,
  };

  private legalTaxLink: PmUiLink = {
    Text: 'Legal & Tax',
    Icon: LegalAndTaxIcon,
    path: `${this.baseUrl}/legalandtax`,
  };

  private invoicingLink: PmUiLink = {
    Text: 'Invoicing',
    Icon: InvoicingIcon,
    path: `${this.baseUrl}/invoices`,
  };

  private billingConfigLink: PmUiLink = {
    Text: 'Billing',
    Icon: BillingConfigIcon,
    path: `${this.baseUrl}/billing`,
  };

  //#endregion

  private paymentsEnabled = true;
  private maintenanceEnabled = false;
  private applicationsEnabled = false;

  constructor(private baseUrl: string) {}

  public BuildList(user: IpaUserExtended|null, featuresEnabled: string[]) {
    const currentUserRole = user?.currentProfile.role;// this.getUserRole(user);

    this.maintenanceEnabled = featuresEnabled.includes('Maintenance');
    this.applicationsEnabled = featuresEnabled.includes('Applications');

    switch (currentUserRole) {
      case Role.PropertyManagerAdmin:
        return this.buildPmAdminLists();
      case Role.PropertyManager:
        return this.buildPmLinks();
      case Role.MaintenanceCoordinator:
        return this.buildMaintCoordinatorLinks();
      case Role.MaintenanceStaff:
        return this.buildMaintStaffLinks();
      case Role.Vendor:
        return this.buildVendorLinks();
      default:
        return [];
    }
  }

  private buildPmAdminLists() {
    //at a minimum, all  PMAdmins will have the payments jazz
    //build payments submenu
    this.paymentsLink.subLinks = [this.transactionsLink, this.depDebLink, this.pmtReqLink, this.bankAccountLink, this.ownerDistLink];

    //build entities submenu
    this.entitiesLink.subLinks = [this.residentsLink, this.propertiesLink, this.ownersLink, this.vendorsLink];

    const pmAdminLinks: PmUiLink[] = [this.dashboardLink, this.paymentsLink, this.entitiesLink, this.integrationsLink];

    //now, add apps if enabled
    if (this.applicationsEnabled) pmAdminLinks.push(this.applicationsLink);

    pmAdminLinks.push(this.staffManagementLink);

    //now, add maint if enabled
    if (this.maintenanceEnabled) pmAdminLinks.push(this.maintenanceLink);

    //build and add settings
    this.settingsLink.subLinks = [this.profileSettingsLink, this.configLink, this.emailReportsLink, this.legalTaxLink, this.invoicingLink, this.billingConfigLink];
    pmAdminLinks.push(this.settingsLink);

    return pmAdminLinks;
  }

  private buildPmLinks() {
    //at a minimum, all  PMs will have the payments jazz
    //build payments submenu
    this.paymentsLink.subLinks = [this.transactionsLink, this.depDebLink, this.pmtReqLink, this.ownerDistLink];

    //build entities submenu
    this.entitiesLink.subLinks = [this.residentsLink, this.propertiesLink, this.ownersLink, this.vendorsLink];

    const pmStaffLinks: PmUiLink[] = [this.dashboardLink, this.paymentsLink, this.entitiesLink];

    //now, add apps if enabled
    if (this.applicationsEnabled) pmStaffLinks.push(this.applicationsLink);

    //now, add maint if enabled
    if (this.maintenanceEnabled) pmStaffLinks.push(this.maintenanceLink);

    //build and add settings
    this.settingsLink.subLinks = [this.profileSettingsLink, this.emailReportsLink];
    pmStaffLinks.push(this.settingsLink);

    return pmStaffLinks;
  }

  private buildMaintCoordinatorLinks() {
    //build entities submenu
    const mcLinks: PmUiLink[] = [this.entitiesLink];
    this.entitiesLink.subLinks = [this.vendorsLink];
    this.settingsLink.subLinks = [this.profileSettingsLink, this.emailReportsLink];
    //now, add maint if enabled
    if (this.maintenanceEnabled) {
      mcLinks.push(this.maintenanceLink);
      //build and add settings
      this.settingsLink.subLinks.push(this.configLink);
    }
    mcLinks.push(this.settingsLink);

    return mcLinks;
  }

  private buildMaintStaffLinks() {
    const msLinks: PmUiLink[] = [];
    this.settingsLink.subLinks = [this.profileSettingsLink, this.emailReportsLink];
    if (this.maintenanceEnabled) msLinks.push(this.maintenanceLink);
    msLinks.push(this.settingsLink);
    return msLinks;
  }

  private buildVendorLinks() {
    const vendorLinks: PmUiLink[] = [];
    this.settingsLink.subLinks = [this.profileSettingsLink];
    if (this.maintenanceEnabled) vendorLinks.push(this.maintenanceLink);
    vendorLinks.push(this.settingsLink);
    return vendorLinks;
  }
}
